export default __webpack_public_path__ + "assets/images/Payment_06.a373b2.webp";